import store from '@core/store/store';
import i18n from '@/i18n'

async function commonLogout(is_alert_duplicate_login) {
    if (typeof is_alert_duplicate_login === 'undefined' || is_alert_duplicate_login === null) {
        is_alert_duplicate_login = localStorage.getItem('is_alert_duplicate_login');
    }

    if (!is_alert_duplicate_login) {
        alert(i18n.t(`다중 로그인 등 권한 오류가 발생했습니다. 다시 로그인해 주십시오.`))
        localStorage.setItem('is_alert_duplicate_login', 1);

        await store.dispatch('logout');
        window.location.href = '/';
    }
}

export default commonLogout;